import type { ComponentPropsWithoutRef } from 'react';
import React from 'react';

export interface TrackingPixelProps extends ComponentPropsWithoutRef<'div'> {
  readonly src: string;
}

export function TrackingPixel({ src, className }: TrackingPixelProps): JSX.Element {
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={src}
      style={{
        display: 'none',
      }}
      className={className}
      alt=""
      decoding="async"
    />
  );
}
TrackingPixel.displayName = 'TrackingPixel';
